import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "runner" }
const _hoisted_2 = { class: "caption" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "status" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { style: {"display":"flex"} }
const _hoisted_7 = {
  key: 0,
  class: "content"
}
const _hoisted_8 = { class: "actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CopyTooltip = _resolveComponent("CopyTooltip")
  const _component_Loader = _resolveComponent("Loader")
  const _component_Button = _resolveComponent("Button")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString($props.caption), 1 /* TEXT */),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createElementVNode("div", null, " Task ID: " + _toDisplayString($options.task_id || 'N/A'), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", {
          class: _normalizeClass({err: $options.task_status === 'failed'})
        }, " Status: " + _toDisplayString($options.task_status), 3 /* TEXT, CLASS */),
        ($options.task_error)
          ? (_openBlock(), _createBlock(_component_CopyTooltip, {
              key: 0,
              class: "copy",
              content: "Error copied to clipboard",
              onCopy: _cache[0] || (_cache[0] = $event => ($options.copyError($options.task_error)))
            }))
          : _createCommentVNode("v-if", true),
        ($options.task_result)
          ? (_openBlock(), _createBlock(_component_CopyTooltip, {
              key: 1,
              class: "copy",
              content: "Result copied to clipboard",
              onCopy: _cache[1] || (_cache[1] = $event => ($options.copyResult()))
            }))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", null, " Created at: " + _toDisplayString($options.task_date), 1 /* TEXT */),
      _createElementVNode("div", null, [
        ($options.task_subtasks)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[3] || (_cache[3] = _createTextVNode(" Subtasks: ")),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.task_subtasks.items, (subtask) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: subtask.id
                  }, [
                    _createElementVNode("span", _hoisted_6, [
                      _createTextVNode("Task ID: " + _toDisplayString(subtask.id) + " - Status: " + _toDisplayString(subtask.status) + " ", 1 /* TEXT */),
                      (subtask.error && subtask.status==='failed')
                        ? (_openBlock(), _createBlock(_component_CopyTooltip, {
                            key: 0,
                            class: "copy",
                            content: "Error copied to clipboard",
                            onCopy: $event => ($options.copyError(subtask.error))
                          }, null, 8 /* PROPS */, ["onCopy"]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _cache[4] || (_cache[4] = _createTextVNode(" Stats: ")),
              _createElementVNode("div", null, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, "Total: " + _toDisplayString($options.task_subtasks.stats.total || 0), 1 /* TEXT */),
                  _createElementVNode("li", null, "Pending: " + _toDisplayString($options.task_subtasks.stats.pending || 0), 1 /* TEXT */),
                  _createElementVNode("li", null, "Running: " + _toDisplayString($options.task_subtasks.stats.running || 0), 1 /* TEXT */),
                  _createElementVNode("li", null, "Completed: " + _toDisplayString($options.task_subtasks.stats.completed || 0), 1 /* TEXT */),
                  _createElementVNode("li", null, "Failed: " + _toDisplayString($options.task_subtasks.stats.failed || 0), 1 /* TEXT */)
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])), [
      [_directive_loading, $data.loading]
    ]),
    (!!_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_Button, {
        primary: "",
        small: "",
        disabled: !$options.can_run,
        onClick: $options.onRunTask
      }, {
        default: _withCtx(() => [
          ($data.running)
            ? (_openBlock(), _createBlock(_component_Loader, {
                key: 0,
                inline: "",
                mini: "",
                color: "white"
              }))
            : _createCommentVNode("v-if", true),
          _cache[5] || (_cache[5] = _createTextVNode(" Run Task "))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "onClick"]),
      ($options.task_subtasks && $options.task_subtasks.stats?.failed)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            onClick: $options.onRestartTask
          }, {
            default: _withCtx(() => [
              ($data.running)
                ? (_openBlock(), _createBlock(_component_Loader, {
                    key: 0,
                    inline: "",
                    mini: "",
                    color: "white"
                  }))
                : _createCommentVNode("v-if", true),
              _cache[6] || (_cache[6] = _createTextVNode(" Restart Task "))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"]))
        : _createCommentVNode("v-if", true),
      (!!$options.task_result?.file_url)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            onClick: _cache[2] || (_cache[2] = $event => ($options.downloadFile()))
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode(" Download ")
            ])),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}